import { Col } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { Cancel, Ecommerce, Invoice, Print } from "../../../Constant";
import ItemDescription from "./ItemDescription";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";

const InvoiceContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef,
  });

  return (
    <>
      <Breadcrumbs pageTitle={Invoice} parent={Ecommerce} title={Invoice} />
      <ItemDescription ref={contentRef} />
      <Col sm="12" className="text-center my-3">
        <Btn color="primary" className="me-2" onClick={handlePrint}>
          {Print}
        </Btn>
        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product`}>
          <Btn color="secondary">{Cancel}</Btn>
        </Link>
      </Col>
    </>
  );
};

export default InvoiceContainer;
